import { FC } from "react";

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const Spotify: FC<Props> = ({
  width = 24,
  height = 24,
  className,
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.01 2.01855C6.51504 2.01855 2.01904 6.51455 2.01904 12.0096C2.01904 17.5046 6.51504 21.9996 12.01 21.9996C17.505 21.9996 22 17.5036 22 12.0096C22 6.51455 17.554 2.01855 12.01 2.01855ZM16.605 16.4546C16.406 16.7536 16.056 16.8546 15.755 16.6556C13.406 15.2056 10.459 14.9056 6.96204 15.7046C6.61404 15.8066 6.31404 15.5566 6.21404 15.2556C6.11304 14.9056 6.36304 14.6076 6.66404 14.5066C10.459 13.6566 13.757 14.0076 16.354 15.6066C16.704 15.7556 16.754 16.1546 16.605 16.4546ZM17.805 13.7076C17.554 14.0566 17.105 14.2066 16.754 13.9566C14.057 12.3106 9.96204 11.8086 6.81504 12.8086C6.41704 12.9096 5.96504 12.7086 5.86604 12.3106C5.76504 11.9086 5.96604 11.4586 6.36504 11.3586C10.011 10.2606 14.508 10.8106 17.604 12.7096C17.904 12.8586 18.054 13.3576 17.805 13.7076ZM17.904 10.9086C14.707 9.01156 9.36204 8.81155 6.31404 9.76255C6.08225 9.82884 5.83386 9.80353 5.6202 9.69186C5.40654 9.58019 5.24395 9.3907 5.16604 9.16255C5.09806 8.93048 5.12244 8.68111 5.23408 8.4666C5.34572 8.25208 5.53597 8.08904 5.76504 8.01155C9.31204 6.96255 15.157 7.16155 18.854 9.36255C19.303 9.61155 19.453 10.2116 19.203 10.6606C18.953 11.0106 18.354 11.1586 17.904 10.9086Z"
        fill={color}
      />
    </svg>
  );
};

export default Spotify;
